module.exports = __webpack_public_path__ + "static/media/207-Kuchen_ID_32.472e12bd.mp3";